'use client'

import type { SVGProps } from 'react'
import * as React from 'react'
import { useState } from 'react'
import { motion, useMotionValueEvent, useScroll } from 'motion/react'

import cn from '@config/tailwind/cn'

export const StickyBanner = ({
  className,
  children,
  hideOnScroll = false,
  onClose,
}: {
  className?: string
  children: React.ReactNode
  hideOnScroll?: boolean
  onClose?: () => void
}) => {
  const [open, setOpen] = useState(true)
  const { scrollY } = useScroll()

  useMotionValueEvent(scrollY, 'change', (latest) => {
    if (hideOnScroll && latest > 40) {
      setOpen(false)
    } else {
      setOpen(true)
    }
  })

  return (
    <motion.div
      className={cn(
        'ui:sticky ui:inset-x-0 ui:top-0 ui:z-40 ui:flex ui:min-h-14 ui:w-full ui:items-center ui:justify-center ui:bg-transparent ui:px-4 ui:py-1',
        className,
      )}
      initial={{
        y: -100,
        opacity: 0,
      }}
      animate={{
        y: open ? 0 : -100,
        opacity: open ? 1 : 0,
      }}
      transition={{
        duration: 0.3,
        ease: 'easeInOut',
      }}
    >
      {children}

      <motion.button
        initial={{
          scale: 0,
        }}
        animate={{
          scale: 1,
        }}
        className='ui:absolute ui:top-1/2 ui:right-2 ui:-translate-y-1/2 ui:cursor-pointer'
        onClick={() => {
          setOpen(!open)
          onClose?.()
        }}
      >
        <CloseIcon className='ui:text-neutral-white ui:size-5' />
      </motion.button>
    </motion.div>
  )
}

const CloseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    >
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M18 6l-12 12' />
      <path d='M6 6l12 12' />
    </svg>
  )
}
